import { Avatar, Box, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { vars } from '@tgtg/kit';
import usersAPISlice from 'api/users/usersAPISlice';
import { useState, type MouseEvent } from 'react';

import UserMenuPopover from '../UserMenuPopover';

const UserMenu = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isPopoverOpen = Boolean(anchorEl);
  const { data: currentUser } = usersAPISlice.endpoints.getCurrentUser.useQuery();

  const handleProfileClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <ListItem
        disablePadding
        sx={{
          borderRadius: vars.radius.medium,
          overflow: 'hidden',
        }}
      >
        <ListItemButton
          onClick={handleProfileClick}
          sx={{
            '&:hover': {
              backgroundColor: vars.color.surface.interactive.opacityOverlayHover,
            },
            ...(isPopoverOpen && {
              backgroundColor: vars.color.surface.interactive.opacityOverlayPressed,
            }),
          }}
        >
          <ListItemAvatar
            sx={{ minWidth: `calc(${vars.size.size400} + ${vars.spacing.neutral.medium})` }}
          >
            <Avatar
              sx={{
                width: vars.size.size400,
                height: vars.size.size400,
                bgcolor: vars.color.surface.interactive.primary,
              }}
            >
              {currentUser?.charityName[0].toUpperCase()}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={currentUser?.charityName}
            primaryTypographyProps={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontWeight: 500,
              fontFamily: vars.typography.labels.medium.fontFamily,
              fontSize: vars.typography.labels.medium.fontSize,
            }}
          />
        </ListItemButton>
      </ListItem>
      <UserMenuPopover
        anchorEl={anchorEl}
        isPopoverOpen={isPopoverOpen}
        onPopoverClose={handlePopoverClose}
      />
    </Box>
  );
};

export default UserMenu;
